export default __webpack_public_path__ + "static/media/Hotel Booking-rafiki.6bb6a4cf.svg";